/**
 * [ File :: G_GraphicHero.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/child/graphic/G_GraphicHero.js
 * @설명 : 그래픽 객체를 상속 받는 히어로 객체 (히어로의 다양한 행동을 정의)
 * @진행 : 종료
 * @주의 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';
import B_Define from 'canvas/base/dev/util/B_Define'
import B_Inventory from 'canvas/base/dev/child/attr/B_Inventory';
import G_Define from 'canvas/grid/dev/util/G_Define'
import G_GraphicMovable from 'canvas/grid/dev/child/graphic/G_GraphicMovable';

let mix = (superclass) => new MixinBuilder(superclass);

const G_GraphicHero = (function () {

	return class extends mix(G_GraphicMovable).with(B_Inventory) {

		constructor(obj) { super(obj); }

		/**
		 * [ Function :: getItem ]
		 *
		 * @DES :: (기본) 아이텝 줍기
		 * @IP1 :: res {str}
		 * @IP2 :: arr {arr}
		 * @IP3 :: cb {func}
		 * @O.P :: null
		 */
		getItem (res, arr, cb) {
			const STATE = this.CODMOS.WORLD.STATE;
			if (typeof res === 'function') {
				cb = res
				res = undefined
			}
			if (typeof cb === 'undefined' && typeof arr === 'function') {
				cb = arr
				arr = undefined
			}

			this._checkMoveStatus(() => {
				const ITEM = this.checkUnderType(G_Define.GET_ITEM_TYPE);
				if (ITEM) {
					if (ITEM._dontGet === true) {
						STATE.going(B_Define.CLEAR_STATUS['FAIL'], G_Define.REASON["DO_NOT_GET"]);
					} else if (res && ITEM._res !== res) {
						STATE.going(B_Define.CLEAR_STATUS['FAIL'], G_Define.REASON["NOT_MATCH_RES"]);
					} else {
						this._insertInventory(ITEM);

						// this.CODMOS.SOUND.play('get'); // sound
						this.CODMOS.ANIMATE.itemUp(ITEM, () => {
							ITEM._remove();
							if (arr) this._variableChange(arr)
							STATE.going(B_Define.CLEAR_STATUS['GOING'], '', ITEM);
						});
					}
				} else STATE.going(B_Define.CLEAR_STATUS['FAIL'], G_Define.REASON["NULL"]);

				this._endAction((result) => {
					if (cb) cb(result);
				});

			});
		}

		changeUnderAttr (key, type, value) {
			let searchType = type || 'path';

			let searchTypeList = this.CODMOS.WORLD.LIST[searchType];
			for (const ID in searchTypeList) {
				const OBJECT = searchTypeList[ID]
				if (
					this._gridX === OBJECT._gridX
					&&
					this._gridY === OBJECT._gridY
				) {
					let crushObjectKey = null

					if (typeof OBJECT[key] !== 'undefined') crushObjectKey = key
					else if (typeof OBJECT['_' + key] !== 'undefined') crushObjectKey = '_' + key

					if (crushObjectKey !== null) {
						const CAL_VALUE = OBJECT[crushObjectKey] + value
						const TARGET_SOLUTION = this.CODMOS.WORLD.LIST.solution[OBJECT._target]
						if (typeof TARGET_SOLUTION !== 'undefined' && TARGET_SOLUTION._compareSetValue(CAL_VALUE) === false)
							return false
						OBJECT[crushObjectKey] = CAL_VALUE
						return OBJECT[crushObjectKey]
					}
				}
			}
		}

		_variableChange (arr) {
			arr = JSON.parse(arr)
			if (!Array.isArray(arr)) return
			return arr.some(e => {
				if (
					Array.isArray(e)
					&& this.CODMOS.WORLD[e[0]]
					&& typeof this.CODMOS.WORLD[e[0]].plusValue === 'function'
				) return this.CODMOS.WORLD[e[0]].plusValue(e[1])
			})
		}

		changeValue (value, arr, cb) {
			if (typeof cb === 'undefined' && typeof arr === 'function') {
				cb = arr
				arr = undefined
			}
			const STATE = this.CODMOS.WORLD.STATE;
			this._checkMoveStatus(() => {
				if (!arr || !this._variableChange(arr)) {
					const CHANGE_VALUE = this.changeUnderAttr('value', 'getItem', value)

					if (CHANGE_VALUE === false) {
						STATE.going(B_Define.CLEAR_STATUS['FAIL'], G_Define.REASON["OBJ_SET"]);
					} else if (typeof CHANGE_VALUE !== 'undefined') {
						STATE.going(B_Define.CLEAR_STATUS['GOING'], '');
					} else {
						STATE.going(B_Define.CLEAR_STATUS['FAIL'], G_Define.REASON["NON_VALUE"]);
					}
				}

				this._endAction((result) => {
					if (cb) cb(result);
				});
			})
		}

		/**
		 * [Function :: actionItem]
		 *
		 * @DES :: (행동) 아이텝 줍기
		 * @IP1 :: cb {func}
		 */
		actionItem(cb) {
			const STATE = this.CODMOS.WORLD.STATE;

			this._checkMoveStatus(() => {
				const ITEM = this.checkUnderType(G_Define.ACTION_ITEM_TYPE);
				if (ITEM) {
					this._insertInventory(ITEM);

					// this.CODMOS.SOUND.play('get'); // sound
					this.CODMOS.ANIMATE.actionUp(ITEM, () => {
						ITEM._remove();
						STATE.going(B_Define.CLEAR_STATUS['GOING'], '', ITEM);
						this._endAction((result) => { if (cb) cb(result); });
					});
				}
				else {
					STATE.going(B_Define.CLEAR_STATUS['FAIL'], G_Define.REASON["NULL"]);
					this._endAction((result) => { if (cb) cb(result); });
				}

			});
		}

		/**
		 * [Function :: pushItem]
		 *
		 * @DES :: 아이템 밀기
		 * @IP1 :: cb {func}
		 * @O.P :: cb
		 * @S.E :: '_pushed'가 동작할때 푸쉬아이템의 그리드 좌표를 보고 히어로의 움직임을 결정합니다.
		 */
		pushItem(cb) {
			/**
			 * [STEP]
			 *
			 * [#01] 움직임 여부 확인
			 * [#02] 앞에 push 타입 아이템 여부 확인
			 * [#03] pushed 요청(앞앞 object 확인해서 return)
			 * [#04] 앞앞에 object 여부 확인
			 * [#05] 애니메이션 (캐릭터 + 푸시아이템)
			 * */

			const STATE = this.CODMOS.WORLD.STATE;

			// [#01]
			this._checkMoveStatus(() => {
				// [#02] 앞에 PUSH-ITEM이 있는지 확인
				const PUSH_ITEM = this.checkFrontType(G_Define.PUSH_ITEM_TYPE, this._rotate);
				if(PUSH_ITEM) {
					// [CASE1] 밀기 <= [#03]
					PUSH_ITEM._pushed(this._rotate, () => {
						this._moveStatus = false; // [#] 행동 종료

						// [#04] 푸쉬가 충돌인지 아닌지 어떻게 확인받지 ... ???
						// => '_pushed'가 동작할때 충돌이 아니면 그리드 위치를 미리 이동시켜 버립니다.
						// => 그래서 히어로가 움직일때 앞에 여부로 알 수 있습니다.
						this.moveForward((rtn) => { if (cb) cb(rtn);});
					});
				}
				else {
					// [CASE2] 중지
					STATE.going(B_Define.CLEAR_STATUS['FAIL'], G_Define.REASON["NULL"]);
					this._endAction((result) => { if (cb) cb(result); });
				}
			});
		}

		/**
		 * [Function :: toggleSwitch]
		 *
		 * @DES :: 스위치 토글
		 * @IP1 :: cb[func]
		 */
		toggleSwitch(cb) {
			/**
			 * [STEP]
			 *
			 * [#01] 움직임 여부 확인
			 * [#02] 앞에 switch 타입 아이템 여부 확인
			 * [#03] 스위치 토글
			 * */
			const STATE = this.CODMOS.WORLD.STATE;

			// #01.
			this._checkMoveStatus(() => {
				// 02.
				const SWITCH = this.checkUnderType("switch");
				if(SWITCH) {
					// 03.
					SWITCH.toggleSwitch(() => {
						STATE.going(B_Define.CLEAR_STATUS['GOING'], '', SWITCH);
						this._endAction((result) => { if (cb) cb(result); });
					});
				}
				else {
					STATE.going(B_Define.CLEAR_STATUS['FAIL'], G_Define.REASON["NULL"]);
					this._endAction((result) => { if (cb) cb(result); });
				}
			});
		}

		/**
		 * [ Function :: readValue ]
		 *
		 * @DES :: 오브젝트 값 읽기 블록에 사용되는 동작
		 * @IP1 :: cb {func}
		 * @O.P :: null
		 */
		readValue (cb) {
			this.readAttr({
				err: 'BUZZ',
				cb: cb
			})
		}

		/**
		 * [ Function :: readAttr ]
		 *
		 * @DES :: 현재 히어로 위치에 놓인 오브젝트의 값을 읽어서 지정된 변수에 삽입
		 * @IP1 :: json {object}
		 * @O.P :: null
		 */
		readAttr (json) {
			const ATTR = json.attr || 'value'
			const TYPE = json.type || 'getItem'
			const TARGET = json.target || this.getUnderAttr('variableTarget', TYPE)
			const ERR = json.err || 'NULL'

			const STATE = this.CODMOS.WORLD.STATE;
			this._checkMoveStatus(() => {

				this._postGetAttr([
					G_Define.GET_ITEM_TYPE,
					G_Define.PATH_TYPE
				], (err) => {
					const VALUE = this.getUnderAttr(ATTR, TYPE)

					if (err === true) {
						STATE.going(B_Define.CLEAR_STATUS['FAIL'], G_Define.REASON[ERR]);
					} else {
						if (typeof VALUE == 'number') {
							this.CODMOS.WORLD[TARGET].setValue(VALUE)
							STATE.going(B_Define.CLEAR_STATUS['GOING'], '');
						} else {
							STATE.going(B_Define.CLEAR_STATUS['FAIL'], G_Define.REASON["NON_VALUE"]);
						}
					}

					this._endAction((result) => {
						if (json.cb) json.cb(result);
					});
				})

			});
		}

		/**
		* [ Function :: getUnderAttr ]
		*
		* @DES :: 아래 속성 값 가져오기
		* @IP1 :: key {str}
		* @IP2 :: type {str}
		* @O.P :: res {any}
		*/
		getUnderAttr (key, type) {
			let searchType = Array.isArray(type) ? type.shift() : type || 'path';

			let searchTypeList = this.CODMOS.WORLD.LIST[searchType];
			for (const ID in searchTypeList) {
				const OBJECT = searchTypeList[ID]
				if (
					this._gridX === OBJECT._gridX
					&&
					this._gridY === OBJECT._gridY
				) {
					if (typeof OBJECT[key] !== 'undefined') {
						return OBJECT[key]
					} else if (typeof OBJECT['_' + key] !== 'undefined') {
						return OBJECT['_' + key]
					}
				}
			}

			if (Array.isArray(type) && typeof type[0] !== 'undefined') return this.getUnderAttr(key, type)
		}

		/**
		 * [ Function :: _postGetAttr ]
		 *
		 * @DES :: 오브젝트 값 읽기 동작 후 솔루션 처리
		 * @IP1 :: type {str}
		 * @IP2 :: cb {func}
		 * @O.P :: null
		 */
		_postGetAttr (type, cb) {
			let CRUSH_OBJECT = false;

			for (let i = 0; i < type.length; i++) {
				const RTN = this.checkUnderType(type[i])
				if (RTN) {
					CRUSH_OBJECT = RTN
					break;
				}
			}

			if (CRUSH_OBJECT) {
				const ACTION_SOLUTION = this.CODMOS.WORLD.LIST[G_Define.ACTION_SOLUTION_TYPE]
				if (!Object.values(ACTION_SOLUTION).some(e => !e._compareGetValue(CRUSH_OBJECT))) {
					cb(false)
				} else {
					cb(true)
				}
			}
		}
	}
}());

export default G_GraphicHero;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/graphic/G_GraphicHero.js